import { compose, groupBy } from 'ramda';
/**
 * @deprecated
 */
export const apiCurrentUser = request => {
  return request('/api/currentUser', {
    method: 'POST'
  });
};
export function docapiGetNodeStatusLog(request, params) {
  return request('/docapi/getNodeStatusLog', {
    method: 'POST',
    data: params
  });
}
export function docapiQueryNodeStatusLog(request, params) {
  return request('/api/status/query', {
    method: 'POST',
    data: params
  });
}
export function docapiRemovePeriodic(request, params) {
  return request('/docapi/removePeriodic', {
    method: 'POST',
    data: params
  });
}
export function docApiSetPeriodic(request, args) {
  const {
    orgId,
    nodeId,
    val
  } = args;
  const baseParams = {
    org_id: orgId,
    node_id: nodeId
  };
  if (!val) {
    return docapiRemovePeriodic(request, baseParams);
  }
  return request('/docapi/setPeriodic', {
    data: {
      ...baseParams,
      _sys_periodic: val
    }
  });
}
const groupByValue = compose(options => Object.values(options).map(o => ({
  ...o[0],
  v: o[0].v,
  n: o.map(i => i.n)
})), groupBy(option => option.v));
export const fetchQuoteNodes = (request, args) => {
  let propIndexs = [];
  if (typeof args.propIndex === 'number') propIndexs = [args.propIndex];else propIndexs = args.propIndex;
  const params = {
    org_id: args.orgId,
    node_id: args.nodeId,
    getQuoteArray: true,
    index: propIndexs
  };
  if (args.shareToken) {
    params.shareToken = args.shareToken;
  }
  if (args.formToken) {
    params.formToken = args.formToken;
  }
  return request('/docapi/execCalcFormula', {
    method: 'POST',
    data: params
  }).then(res => res.data).then((res = []) => res.reduce((result, options, index) => {
    let newOptions;
    if (!options) return result;
    if (Array.isArray(options)) {
      newOptions = options;
    } else {
      // @ts-ignore
      if (options.l) {
        return result;
      }
      if (typeof options !== 'object') {
        return result;
      }
      newOptions = [options];
    }
    return {
      ...result,
      [propIndexs[index]]: groupByValue(newOptions.map(o => Array.isArray(o.v) ? o.v.map(item => ({
        ...o,
        v: item,
        n: o.n
      })) : o).flat())
    };
  }, {}));
};